import React from 'react'
import { Link } from 'react-router-dom'
import { ESGLedgerLogo } from '../components/ESGLedgerLogo'
import LiveRecycleFeed from '../components/LiveRecycleFeed'

/**
 * Public live feed of recycle events pushed from the Arduino station
 * after a successful OneChain commit (POST /api/ingest/recycle).
 */
const TransactionPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-teal-50 to-white">
      <header className="border-b border-primary-100/80 bg-white/70 backdrop-blur sticky top-0 z-20">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-2">
          <Link to="/" className="inline-flex items-center" aria-label="Back to homepage">
            <ESGLedgerLogo className="h-12 md:h-16" />
          </Link>
        </div>
      </header>

      <main>
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 pt-5 pb-1">
          <h1 className="font-display text-3xl md:text-5xl font-bold text-primary-900">
            Transactions
          </h1>
        </div>

        <LiveRecycleFeed
          variant="page"
          limit={50}
          showHeading={false}
        />
      </main>
    </div>
  )
}

export default TransactionPage
